import request from '@/utils/request'
// 关于我们接口
export function GetGuanyu(data) {
  return request({
    url: '/admin/auth/html/info',
    method: 'get',
    params: { data }
  })
}


// WEBPACK FOOTER //
// ./src/api/guanyu.js